import styled from "styled-components";

import { GamificationCardContainer } from "pages/[tenant]/g/[group_slug]/moderation/components/Gamification/components/atoms/GamificationCard/styles";
import { gamificationIn } from "pages/[tenant]/g/[group_slug]/moderation/components/Gamification/utils/animations";

export const MissionPageContainer = styled.section`
  background-color: ${({ theme }) =>
    theme.groups.gamification.pageBackgroundColor};
  margin-top: 6.875rem;
  width: 100%;
  height: calc(100% - 6.875rem);

  .mission-page-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 2rem 1rem 0 1rem;

    display: flex;
    gap: 2rem;
    justify-content: space-between;

    animation-name: ${gamificationIn};
    animation-duration: 500ms;

    width: 100%;

    @media screen and (max-width: 1366px) {
      max-width: 966px;
    }

    @media screen and (max-width: 1280px) {
      max-width: 880px;
    }

    @media screen and (max-width: 850px) {
      display: grid;
      grid-template-columns: 1fr;
      grid-template-rows: 1fr;
      grid-template-areas: "activeMission" "missionGoals" "listMissions";
      margin: 0 auto;
    }
  }
`;

export const NoMissionsFound = styled.div`
  width: 100%;
  height: 100%;

  display: flex;
  justify-content: center;

  ${GamificationCardContainer} {
    color: ${({ theme }) => theme.groups.primaryText};
  }
`;
